import React, { FC } from "react"
import { observer } from "mobx-react-lite"
import { Appearance, TextStyle, TouchableOpacity, ViewStyle } from "react-native"
import { JalaIcon, Screen, Text } from "../../components"
import { CompositeScreenProps } from "@react-navigation/native"
import { useStores } from "../../models"
import { LoginStackSplash, resetRoot } from "../../navigators"
import { color } from "../../theme"

const ROOT: ViewStyle = {
  backgroundColor: color.background,
  flex: 1,
}

const LINEROW: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  paddingHorizontal: 16,
  paddingVertical: 16,
  backgroundColor: color.palette.white
}

const BUTTONTEXT: TextStyle = {
  color: color.palette.gray800,
  marginLeft: 12
}

export const ChangeLanguageScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function ChangeLanguageScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  // Pull in one of our MST stores
  const { appStore: { locale, setLocale }, userStore } = useStores();

  const handleChange = (key: "en"|"id"|"es"|"vi") => () => {
    userStore.updateLocale(key)
      .then(() => userStore.getUser(false))
    setLocale(key)
    resetRoot(LoginStackSplash)
  }


  const lineRow = (text, key) => {
    const isActive = locale === key;
    const iconColor = isActive ? color.palette.green500 : color.palette.white;
    return (
      <TouchableOpacity style={LINEROW} onPress={handleChange(key)}>
        <JalaIcon name="check" size={20} color={iconColor} />
        <Text style={BUTTONTEXT} tx={text} preset="body2" />
      </TouchableOpacity>
    )
  }

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={color.primary}
      statusBar="light-content"
    >
      {lineRow('changeLanguage.Indonesia', 'id')}
      {lineRow('changeLanguage.english', 'en')}
      {lineRow('changeLanguage.vietnamese', 'vi')}
      {lineRow('changeLanguage.espanol', 'es')}
    </Screen>
  )
})
